import { SignOut } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';

import pt from '../../locales/pt';
import { paths } from '../../routes/paths';
import { useAuth } from '../../store/AuthContext';
import { Button } from '../ui/Button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '../ui/Dialog';

export function LogoutConfirmDialog({ open, onOpenChange }) {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const onConfirm = async () => {
    await logout();
    onOpenChange(false);
    navigate(paths.signIn);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent hideClose className="max-w-sm text-center">
        <div className="mx-auto flex h-[52px] w-[52px] items-center justify-center rounded-2xl bg-muted text-muted-foreground">
          <SignOut className="h-6 w-6" aria-hidden />
        </div>
        <DialogTitle className="mt-4 text-center text-xl">{pt.settings.logout.title}</DialogTitle>
        <DialogDescription className="text-center">{pt.settings.logout.body}</DialogDescription>
        <div className="mt-5 flex gap-2.5">
          <Button
            type="button"
            variant="outline"
            className="flex-1"
            onClick={() => onOpenChange(false)}
          >
            {pt.common.cancel}
          </Button>
          <Button type="button" className="flex-1" onClick={onConfirm}>
            {pt.settings.logout.confirm}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
